module.exports = __webpack_public_path__ + "static/hanisch-0adb6d35112bcbca73a16a665c58df06.jpg";